module.exports = "../static/media/banner.e26a8b22.png";